import React from 'react'
import { List } from '@mui/material';
import EditItem from '../EditItem/EditItem'
import '../ListItems/ListItems.css'
function EditList({stateList, removeItem, setOpen, setMessage}) {

  return (
    <List className='package-name'>
      {
        stateList.map((key, index) => {
            return (
              <EditItem 
                key={index}
                className='package-name-child'
                id={key}
                word={key}
                removeItem={removeItem}
                setOpen={setOpen}
                setMessage={setMessage}
                stateList={stateList}
                index={index}
              />
            );
        })
      }
    </List>

  )
}

export default EditList